import _ from 'lodash'
import type { MeshComponent } from '@wix/thunderbolt-becky-types'

type ComponentLayoutRetriever = (comp: MeshComponent) => number
// @ts-ignore
export const top: ComponentLayoutRetriever = (comp) => comp.top
// @ts-ignore
export const left: ComponentLayoutRetriever = (comp) => comp.left
// @ts-ignore
export const bottom: ComponentLayoutRetriever = (comp) => comp.top + comp.height
export const height: ComponentLayoutRetriever = (comp) => comp.height || 0
export const fitToContentHeight = (container: MeshComponent) => Boolean(container.fitToContentHeight)
export const getContainerHeight = (container: MeshComponent) => _.max([container.height || 0, container.minHeight || 0])
export const isRotated = (component: MeshComponent) =>
	_.isNumber(component.rotationInDegrees) && component.rotationInDegrees !== 0
